import { createStyles } from 'antd-style'

export const useStyles = createStyles({
  radioGroup: {
    display: 'flex',
    gap: '8px 0',
    flexWrap: 'wrap'
  }
})
